import React, { ReactElement } from 'react';

import { Sheet } from '../../../../../mobile/structural/sheet/Sheet';
import { UseSheetReturnType } from '../../../../../mobile/structural/sheet/hooks/useSheet';
import CellTypePopup from '../../../../../element/table/cellTypes/CellTypePopup';
import { CellTypeNames } from '../../../../../../common/table/CellTypeConstants';
import { CellTypeObjectWithAuto } from '../../../../../../common/table/TableTypes';

import './MobileCellTypeSheet.scss';

type Props = {
    sheetProps: UseSheetReturnType;
    locale: string;
    activeCellType: CellTypeNames | undefined;
    sharedCellTypeFormatOptions: CellTypeObjectWithAuto | undefined;
    lastClickedType: CellTypeNames | null;
    setLastClickedType: (type: CellTypeNames) => void;
};

const MobileCellTypeSheet = (props: Props): ReactElement => {
    const { sheetProps, ...cellTypePopupProps } = props;

    return (
        <Sheet className="MobileCellTypeSheet" {...sheetProps}>
            <Sheet.Overlay />
            <Sheet.Panel>
                <Sheet.Content>
                    <div className="CellTypePopup">
                        <CellTypePopup {...cellTypePopupProps} closePopup={null} showInlineFormattingOptions={false} />
                    </div>
                </Sheet.Content>
            </Sheet.Panel>
        </Sheet>
    );
};

export default MobileCellTypeSheet;
